/* DO NOT MODIFY FILE, IT IS READ-ONLY. Make a merge request to the widget template to modify. */
import * as globalObject from '@skbkontur/global-object';
import * as react from 'react';
import * as reactDOM from 'react-dom';
import * as reactJsxRuntime from 'react/jsx-runtime';

export const dependencies = {
	globalObject,
	react,
	reactJsxRuntime,
	reactDOM,
} as const;
